exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles__row___2YJ6o {\n  position: relative;\n  margin-bottom: 20px; }\n\n@media (max-width: 768px) {\n  .styles__col___2Q3zP {\n    margin-top: 10px; } }\n\n.styles__addRow___1Vaq7 {\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  padding: 10px 0;\n  margin-bottom: 20px;\n  color: #f94144; }\n  .styles__addRow___1Vaq7 > span {\n    margin-left: 8px;\n    font-weight: 600;\n    text-decoration: underline; }\n\n.styles__removeRow___1_1dK {\n  display: block;\n  cursor: pointer;\n  position: absolute;\n  right: -40px;\n  top: 45px; }\n  @media (min-width: 768px) {\n    .styles__removeRow___1_1dK {\n      right: -40px;\n      top: 35px; } }\n  .styles__removeRow___1_1dK > img {\n    width: 20px;\n    height: 20px; }\n", ""]);

// exports
exports.locals = {
	"row": "styles__row___2YJ6o",
	"col": "styles__col___2Q3zP",
	"addRow": "styles__addRow___1Vaq7",
	"removeRow": "styles__removeRow___1_1dK"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/FormControls/Tyres/styles.scss
// module id = 4627
// module chunks = 6